import Navbar from "../components/common/Navbar";
import CelebHero from "../components/celebrityMarketing/CelebHero";
import CelebSides from "../components/celebrityMarketing/CelebSides";
import CelebAudience from "../components/celebrityMarketing/CelebAudience";
import CelebUses from "../components/celebrityMarketing/CelebUses";
import CelebProcess from "../components/celebrityMarketing/CelebProcess";
import CelebWhy from "../components/celebrityMarketing/CelebWhy";
import CelebCta from "../components/celebrityMarketing/CelebCta";
// Shares the Events & Experiences theme (type, buttons, section spacing),
// plus the Influencer page's staircase cards (.im-step-*) used by CelebWhy.
// Scroll position on arrival is handled by MainLayout.
import "../styles/eventsExperiences.css";
import "../styles/influencerMarketing.css";
import "../styles/celebrityMarketing.css";

const CelebrityMarketingPage = () => (
  <div className="ee cm">
    <Navbar />
    <CelebHero />
    <CelebSides />
    <CelebAudience />
    <CelebUses />
    <CelebProcess />
    <CelebWhy />
    <CelebCta />
  </div>
);

export default CelebrityMarketingPage;
